<template>
  <div>
    <OnboardingTextSection>
      Рекламные кампании из разных рекламных<br>
      площадок в Marilyn называются <b>размещениями</b>.
    </OnboardingTextSection>

    <OnboardingTextSection>
      Именно во вкладке с размещениями происходит<br>
      добавление рекламных кампаний из кабинетов в<br> систему Marilyn.
    </OnboardingTextSection>
  </div>
</template>

<script>
  import OnboardingTextSection from 'onboarding/onboardings/components/OnboardingTextSection';

  export default {
    name: 'PlacementsInfoStep',
    components: {OnboardingTextSection}
  };
</script>
